import { message, notification } from 'antd';
import { always, cond, equals, is, prop, T } from 'ramda';
import { isTrue } from 'ramda-adjunct';
import { CheckCircleFilled, ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import React from 'react';
import { SCOPE_OFFER } from '../_CONST';

export const customSuccessMessage = (content) =>
  message.success({
    content,
    icon: <CheckCircleFilled className="!text-flexi-valid" />,
    className: 'ant-message-notice-success'
  });

export const successMessage = (type, action, apostrophe, feminine, plural, endMsg) => {
  const headMsg = cond([
    [() => isTrue(plural), always('Les ')],
    [isTrue, always('L\'')],
    [() => isTrue(feminine), always('La ')],
    [T, always('Le ')]
  ])(apostrophe);
  const messageFormatted = isTrue(plural) ? `${headMsg}${type}s ont bien été ${action}s${endMsg || ''}.` : `${headMsg}${type} a bien été ${action}.`;
  return customSuccessMessage(messageFormatted);
};
export const errorMessage = (content = 'Une erreur est survenue, veuillez réessayer.') => message.error({
  content,
  icon: <ExclamationCircleFilled className="!text-flexi-error" />,
  className: 'ant-message-notice-error'
});
export const infoMessage = (content) => message.info({
  content,
  icon: <InfoCircleFilled className="!text-flexi-primary-color" />,
  className: 'ant-message-notice-info'
});

export const deleteMutationMessage = (ok, error, type, cb, apostrophe, feminine, plural) => {
  if (ok && !error) {
    successMessage(type, 'supprimé', apostrophe, feminine, plural);
  } else {
    errorMessage();
  }
  if (cb && is(Function, cb)) cb(ok, error);
};

export const updateMutationMessage = (ok, error, type, cb, reload) => {
  if (ok && !error) {
    successMessage(`Le contenu du ${type}`, 'mise à jour');
    if (reload) window.location.reload();
  } else {
    errorMessage();
  }
  if (cb && is(Function, cb)) cb(ok, error);
};

export const callbackSave = (type, successMessage, history, scope, state, offerId) => (ok, error) => {
  if (ok && !error) {
    customSuccessMessage(successMessage);
    if (equals(scope, SCOPE_OFFER) || equals(prop('scope', state), SCOPE_OFFER)) {
      history.push(`/offre/${offerId || prop('offerId', state)}/edition`);
    } else {
      history.push(`/equipe/${type}`);
    }
  } else {
    if (equals('name_already_exist', error)) {
      errorMessage('Le nom indiqué existe déjà.');
    } else {
      errorMessage();
    }
  }
};

export const successNotification = (message, description = null) => notification.success({
  message, description, icon: <CheckCircleFilled className="!text-flexi-valid" />, placement: 'top'
});

export const errorNotification = (message = 'Une erreur est survenue.', description = 'Veuillez réessayer.') => notification.error({
  message, description, icon: <ExclamationCircleFilled className="!text-flexi-error" />, placement: 'top'
});
